<template>
  <div>
    <div class='recent-match-title'>
      <div>{{ $t("playerSeasonStats.game") }}</div>
      <div>{{ $t("playerSeasonStats.minutes") }}</div>
      <div>{{ $t("playerSeasonStats.rebounds") }}</div>
      <div>{{ $t("playerSeasonStats.assists") }}</div>
      <div>{{ $t("playerSeasonStats.steals") }}</div>
      <div>{{ $t("playerSeasonStats.blockShots") }}</div>
      <div>{{ $t("playerSeasonStats.points") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recent-match-title'
}
</script>

<style lang="sass" scoped>
@import '../styles'

.recent-match-title
  @extend %titleRow

  div:nth-child(1)
    width: vw(129)
    text-align: initial

  div:nth-child(n+3)
    width: vw(31)

  div:nth-child(2)
    width: vw(36)

</style>
